<template>
  <FiltersDesktop
    v-model:filtersValues="filtersValues"
    class="mb-32 hidden md:block"
    :resetFilters
    :shouldShowFilter
    :shouldShowMissingActionFilter
    :shouldShowOrderStateFilter
    :submitFilters
  />
  <FiltersMobile
    v-model:filtersValues="filtersValues"
    class="md:hidden"
    :resetFilters
    :shouldShowFilter
    :shouldShowMissingActionFilter
    :shouldShowOrderStateFilter
    :submitFilters
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { FILTERS_BY_PUBLICATION_STATE } from './Filters.constants'
import type { FilterValues } from './Filters.types'
import FiltersDesktop from './components/FiltersDesktop/FiltersDesktop.vue'
import FiltersMobile from './components/FiltersMobile/FiltersMobile.vue'

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

const props = defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  publicationState: string
}>()

function shouldShowFilter(filter: string) {
  return FILTERS_BY_PUBLICATION_STATE[props.publicationState].includes(filter)
}

const shouldShowMissingActionFilter = computed(
  () => props.publicationState === 'needing-response',
)
const shouldShowOrderStateFilter = computed(
  () =>
    props.publicationState === 'needing-response' ||
    props.publicationState === 'all',
)
</script>
